// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type CampaignReportsQueryVariables = PrivateSchemaTypes.Exact<{
  campaignId: PrivateSchemaTypes.Scalars['PositiveInt'];
  filter: PrivateSchemaTypes.CampaignReportsFilterInput;
}>;


export type CampaignReportsQuery = (
  { __typename?: 'Query' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerQueries' }
    & { campaign?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'CampaignModelAsAdminQueries' }
      & Pick<PrivateSchemaTypes.CampaignModelAsAdminQueries, 'id'>
      & { report?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'CampaignReport' }
        & Pick<PrivateSchemaTypes.CampaignReport, 'usersCount'>
        & { users: Array<(
          { __typename?: 'CampaignUserReportRow' }
          & Pick<PrivateSchemaTypes.CampaignUserReportRow, 'firstJoinDate' | 'lastCampaignEvent'>
          & { user?: PrivateSchemaTypes.Maybe<(
            { __typename?: 'UserModelAsAdminQueries' }
            & Pick<PrivateSchemaTypes.UserModelAsAdminQueries, 'id' | 'display_name' | 'image_url' | 'profile_img_url'>
            & { manager?: PrivateSchemaTypes.Maybe<(
              { __typename?: 'UserModelPublicBase' }
              & Pick<PrivateSchemaTypes.UserModelPublicBase, 'id' | 'display_name' | 'image_url' | 'profile_img_url'>
            )> }
          )>, scheduledActions?: PrivateSchemaTypes.Maybe<Array<(
            { __typename?: 'ScheduledActionReport' }
            & Pick<PrivateSchemaTypes.ScheduledActionReport, 'id' | 'campaign_topic_share_action_id' | 'campaign_pathway_share_action_id' | 'campaign_survey_share_action_id' | 'campaign_certification_share_action_id' | 'campaign_message_action_id' | 'campaign_email_action_id' | 'campaign_banner_id' | 'scheduled_time'>
            & { processedNotification?: PrivateSchemaTypes.Maybe<(
              { __typename?: 'NotificationQueueProcessedModel' }
              & Pick<PrivateSchemaTypes.NotificationQueueProcessedModel, 'id' | 'state'>
            )>, pathwayEnrolmentsEvent?: PrivateSchemaTypes.Maybe<(
              { __typename?: 'EnrolmentEvent' }
              & Pick<PrivateSchemaTypes.EnrolmentEvent, 'sent' | 'started' | 'completed'>
            )>, certificationEnrolmentsEvent?: PrivateSchemaTypes.Maybe<(
              { __typename?: 'EnrolmentEvent' }
              & Pick<PrivateSchemaTypes.EnrolmentEvent, 'sent' | 'started' | 'completed'>
            )>, messageEvent?: PrivateSchemaTypes.Maybe<(
              { __typename?: 'MessageSendEvent' }
              & Pick<PrivateSchemaTypes.MessageSendEvent, 'sent'>
            )>, surveysEvent?: PrivateSchemaTypes.Maybe<(
              { __typename?: 'EnrolmentEvent' }
              & Pick<PrivateSchemaTypes.EnrolmentEvent, 'sent' | 'started' | 'completed'>
            )>, topicEnrolmentsEvent?: PrivateSchemaTypes.Maybe<(
              { __typename?: 'EnrolmentEvent' }
              & Pick<PrivateSchemaTypes.EnrolmentEvent, 'sent' | 'started' | 'completed'>
            )>, emailEvent?: PrivateSchemaTypes.Maybe<(
              { __typename?: 'EmailEvent' }
              & Pick<PrivateSchemaTypes.EmailEvent, 'sent' | 'opened' | 'clicked'>
            )>, bannerEvent?: PrivateSchemaTypes.Maybe<(
              { __typename?: 'BannerEvent' }
              & Pick<PrivateSchemaTypes.BannerEvent, 'shown' | 'clicked'>
            )> }
          )>> }
        )> }
      )> }
    )> }
  )> }
);


export const CampaignReportsDocument = gql`
    query CampaignReports($campaignId: PositiveInt!, $filter: CampaignReportsFilterInput!) {
  admin {
    campaign(id: $campaignId) {
      id
      report(filter: $filter) {
        usersCount
        users {
          firstJoinDate
          lastCampaignEvent
          user {
            id
            display_name
            image_url
            profile_img_url
            manager {
              id
              display_name
              image_url
              profile_img_url
            }
          }
          scheduledActions {
            id
            campaign_topic_share_action_id
            campaign_pathway_share_action_id
            campaign_survey_share_action_id
            campaign_certification_share_action_id
            campaign_message_action_id
            campaign_email_action_id
            campaign_banner_id
            scheduled_time
            processedNotification {
              id
              state
            }
            pathwayEnrolmentsEvent {
              sent
              started
              completed
            }
            certificationEnrolmentsEvent {
              sent
              started
              completed
            }
            messageEvent {
              sent
            }
            surveysEvent {
              sent
              started
              completed
            }
            topicEnrolmentsEvent {
              sent
              started
              completed
            }
            emailEvent {
              sent
              opened
              clicked
            }
            bannerEvent {
              shown
              clicked
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCampaignReportsQuery__
 *
 * To run a query within a React component, call `useCampaignReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignReportsQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCampaignReportsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CampaignReportsQuery, CampaignReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CampaignReportsQuery, CampaignReportsQueryVariables>(CampaignReportsDocument, options);
      }
export function useCampaignReportsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CampaignReportsQuery, CampaignReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CampaignReportsQuery, CampaignReportsQueryVariables>(CampaignReportsDocument, options);
        }
export type CampaignReportsQueryHookResult = ReturnType<typeof useCampaignReportsQuery>;
export type CampaignReportsLazyQueryHookResult = ReturnType<typeof useCampaignReportsLazyQuery>;
export type CampaignReportsQueryResult = Apollo.QueryResult<CampaignReportsQuery, CampaignReportsQueryVariables>;